import React, { useEffect, useState } from "react";
import MessageModal from "../../../../customComponents/MessageModal";
import { modalOpType, msgType } from "../../../../utils/types";
import { DEFAULT_TIME, emptyMessage } from "../../../../utils/constants";
import { Form, Formik } from "formik";
import { meetingValidation } from "../../../../utils/validationSchema";
import { Button } from "../../../../stories/Button/Button";
import { useLazyQuery, useMutation } from "@apollo/client";
import { AddMom, UpdateMom } from "./queries/mutations";
import { Operation } from "../../../../utils/Enum.types";
import
{
  AddMomResult,
  AddMomVars,
  AtsMomMaster,
  AtsMomMasterOrderField,
  UpdateMomMutation,
  UpdateMomMutationVariables
} from "./queries/types";
import useUrlParams from "../../../../customHooks/useUrlParams";
import useLoggedInUserDetails from "../../../../customHooks/useLoggedInUserDetails";
import
{
  toInputStandardDate,
  toIsoDate
} from "../../../../utils/UtilFunctions";
import { getMomByNodeId, GetMoms } from "./queries/query";
import { OrderDirection } from "../../../../utils/commonQueryTypes";
import { nodeVar } from "../masters/grouping/queries/types";
import { Title } from "../../../../stories/Title/Title";
import Close from "../../../../images/Close.svg";
import Input from "../../../../stories/Input/Input";
import { Label } from "../../../../stories/Label/Label";
import useServerDateandTime from "../../../../customHooks/useServerDateandTime";
import { fromToDatesType } from "../../../../utils/formTypes";
interface Props
{
  addMeeting: modalOpType;
  setModal: React.Dispatch<React.SetStateAction<modalOpType>>;
  dates: fromToDatesType
}
const AddMeeting = ( { addMeeting, setModal, dates }: Props ) =>
{
  const [ message, setMessage ] = useState<msgType>( emptyMessage );
  const [ formData, setFormData ] = useState( {
    meetingDate: ""
  } );
  const { customer_id } = useUrlParams();
  const { user_details } = useLoggedInUserDetails();

  const { serverDate } = useServerDateandTime();
  const [ addMom, { loading: addMomLoading } ] = useMutation<
    AddMomResult,
    AddMomVars
  >( AddMom, {
    onError: ( e ) =>
    {
      setMessage( {
        flag: true,
        message: e.message,
        operation: Operation.NONE
      } );
    }
  } );

  const [ updatedMom, { loading: updateLoading } ] = useMutation<
    UpdateMomMutation,
    UpdateMomMutationVariables
  >( UpdateMom, {
    onError: ( e ) =>
    {
      setMessage( {
        flag: true,
        message: e.message,
        operation: Operation.NONE
      } );
    }
  } );

  const [ GetMomdataForUpdate, { data } ] = useLazyQuery<
    { node: AtsMomMaster },
    nodeVar
  >( getMomByNodeId );

  useEffect( () =>
  {
    if ( addMeeting.operation === Operation.UPDATE && addMeeting.id )
    {
      GetMomdataForUpdate( {
        variables: {
          id: addMeeting.id
        }
      } ).then( ( { data } ) =>
      {
        if ( data && data.node )
        {
          setFormData( {
            meetingDate: toInputStandardDate( data.node.meetingDate )
          } );
        }
      } );
    }
  }, [ addMeeting.id, GetMomdataForUpdate, data ] );

  useEffect( () =>
  {
    if ( serverDate && addMeeting.operation === Operation.CREATE )
    {
      setFormData( ( prevValues ) => ( {
        ...prevValues,
        meetingDate: toInputStandardDate( serverDate )
      } ) );
    }
  }, [ serverDate, addMeeting.operation ] );

  const handleSubmit = ( values: typeof formData ) =>
  {
    if ( customer_id )
    {
      if ( addMeeting.operation === Operation.CREATE )
        addMom( {
          variables: {
            customerID: customer_id,
            user_details,
            meetingDate: toIsoDate( values.meetingDate )
          },
          refetchQueries: [
            {
              query: GetMoms,
              variables: {
                after: null,
                first: 10,
                startDate: dates.startDate ? toIsoDate( dates.startDate ) : undefined,
                endDate: dates.startDate ? toIsoDate( dates.endDate ) : undefined,
                customerID: customer_id,
                orderBy: {
                  direction: OrderDirection.ASC,
                  field: AtsMomMasterOrderField.MEETING_DATE
                }
              }
            }
          ]
        } ).then( ( { data } ) =>
        {
          if ( data && data.AddMom )
          {
            setMessage( {
              flag: true,
              message: "Meeting added successfully",
              operation: Operation.CREATE
            } );
          }
        } );

      if ( addMeeting.operation === Operation.UPDATE && addMeeting.id )
        updatedMom( {
          variables: {
            momID: addMeeting.id,
            user_details,
            meetingDate: toIsoDate( values.meetingDate )
          },
          refetchQueries: [
            {
              query: GetMoms,
              variables: {
                after: null,
                first: 10,
                customerID: customer_id,
                startDate: toIsoDate( DEFAULT_TIME ),
                endDate: toIsoDate( DEFAULT_TIME ),
                orderBy: {
                  direction: OrderDirection.ASC,
                  field: AtsMomMasterOrderField.MEETING_DATE
                }
              }
            }
          ]
        } ).then( ( { data } ) =>
        {
          if ( data && data.UpdateMom )
          {
            setMessage( {
              flag: true,
              message: "Meeting updated successfully",
              operation: Operation.UPDATE
            } );
          }
        } );
    }
  };

  const handleClose = () =>
  {
    if ( message.flag && message )
    {
      handleClear();
      setModal( {
        flag: false,
        operation: Operation.NONE
      } );
    }
    setMessage( emptyMessage );
  };

  const handleClear = () =>
  {
    setFormData( {
      meetingDate: ""
    } );
  };

  return (
    <>
      <div className="meetings__add">
        <div className="meetings__add--title">
          <Title>Add Meeting Date</Title>
          <img
            src={Close}
            alt=""
            onClick={() =>
              setModal( { flag: false, operation: Operation.CREATE } )
            }
          />
        </div>
        <Formik
          initialValues={formData}
          validationSchema={meetingValidation}
          onSubmit={handleSubmit}
          enableReinitialize
          validateOnChange
        >
          {( meta ) =>
          {
            return (
              <Form >
                <div className="meetings__add--label-grid">
                  <Label>Meeting Date</Label>
                  <Input
                    type="date"
                    value={formData.meetingDate}
                    onChange={( e ) =>
                    {
                      setFormData( {
                        meetingDate: e.target.value
                      } );
                    }}
                    name="meetingDate"
                    autoFocus
                    required
                  />
                </div>

                <div className="maps-item-details__asset--flex">
                  <div>
                    <Button
                      mode="save"
                      type="submit"
                      loading={addMomLoading || updateLoading}
                    />
                    <Button
                      mode="clear"
                      loading={addMomLoading || updateLoading}
                      onClick={() =>
                      {
                        handleClear();
                      }}
                    ></Button>

                    <Button
                      mode="cancel"
                      type="button"
                      loading={addMomLoading || updateLoading}
                      onClick={() =>
                      {
                        setModal( { flag: false, operation: Operation.CREATE } );
                      }}
                    />
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>

      {/* <CustomModal
          isOpen={viewTicketDetails}
          onRequestClose={() => setViewTicketDetails(!viewTicketDetails)}
          contentComponent={
            <ViewTicketDetails setModalFlag={setViewTicketDetails} />
          }
          style={ViewTicketModalStyles}
        /> */}

      <MessageModal
        handleClose={handleClose}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
    </>
  );
};

export default AddMeeting;
